export const ONLYFANS_PREFIX = 'OF'
